import * as Yup from 'yup';

export const signUpSchema = Yup.object({
  business_name: Yup.string().min(2, 'Business Name must be at least 2 characters').max(50).required('Please enter your business name'),
  email: Yup.string().email("Invalid email").required('Please enter your email'),
  mobno: Yup.string().min(10, 'Mobile number must be 10 number').required('Please enter your mobile number'),
  password: Yup.string().min(6, 'Password must be at least 6 characters').required('Please enter your password')
})

export const InvoiceSchema = Yup.object().shape({
  title: Yup.string().min(2, 'Title must be at least 2 characters').required('Title is required'),
  description: Yup.string().required('Description is required'),
  price: Yup.number().required('Price is required').positive('Price must be positive'),
});

// export const basicDetailsSchema = Yup.object().shape({
//   country_id: Yup.string().required('Country is required'),
//   state_id: Yup.string().required('State is required'),
//   city_id: Yup.string().required('City is required'),
//   street: Yup.string().required('Street is required'),
//   // locality_id: Yup.string().required('Locality is required'),
//   locality_id: Yup.string().nullable().notRequired(),
//   pincode: Yup.string()
//     .matches(/^[0-9]{5,6}$/, 'Invalid Pincode')
//     .required('Pincode is required'),
//   // email: Yup.string().email('Invalid email').required('Email is required'),
//   mobno: Yup.string()
//     // .matches(/^[0-9]{10}$/, 'Invalid Mobile Number')
//     .required('Mobile Number is required'),
//   // workingSince: Yup.string().required('Working since is required'),
//   // introduction: Yup.string().required('Introduction is required'),
//   gst: Yup.string()
//     .matches(/^[0-9A-Z]{15}$/, 'Invalid GST Number')
//     .nullable(),
// });

export const basicDetailsSchema = Yup.object().shape({
  country_id: Yup.string().required("Country is required"),
  state_id: Yup.string().required("State is required"),
  city_id: Yup.string().required("City is required"),
  street: Yup.string().required("Street is required"),
  locality_id: Yup.string().when("country_id", {
    is: (val) => val === "4Dj1nUEkp4vFOh4HI0CL", 
    then: (schema) => schema.required("Locality is required"),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  pincode: Yup.string()
    .matches(/^[0-9]{4,6}$/, "Invalid Pincode")
    .required("Pincode is required"),
  mobno: Yup.string().required("Mobile Number is required"),
  gst: Yup.string()
    .matches(/^[0-9A-Z]{15}$/, "Invalid GST Number")
    .nullable(),
    // introduction: Yup.string()
    // .min(160, "Business introduction must be at least 160 characters")
    // .required("Business introduction is required"),
});

export const passwordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long'),
  confirmPassword: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

export const WeddingPlannerTTKSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  planningType: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Planning Type Value is required'),
        label: Yup.string().required('Planning Type Label is required'),
      })
    )
    .min(1, 'Planning Type field is required'),
  areaOfWork: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Area Of Work Value is required'),
        label: Yup.string().required('Area Of Work Label is required'),
      })
    )
    .min(1, 'Area Of Work field is required'),
  serviceOffered: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Service Offered Value is required'),
        label: Yup.string().required('Service Offered Label is required'),
      })
    )
    .min(1, 'Service Offered field is required'),
  budget: Yup.number().required('Services Starts At is required'),
  CoverdofEvents: Yup.number().required('Number of events covered is required'),
  Fees: Yup.string().required('Fees structure is required'),
})

export const venueTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  // Additional fields validation
  parkingSize: Yup.string().required('Parking size is required'),
  vegPrice: Yup.number()
    .min(0, 'Veg price must be a positive number or zero')
    .required('Veg price is required'),
  nonVegPrice: Yup.number()
    .min(0, 'Non Veg price must be a positive number or zero')
    .required('Non Veg price is required'),
  roomCount: Yup.number().integer('Room count must be an integer')
  .min(0, 'Room count must be 0 or a positive number')
  .required('Room count is required'),
avgRoomPrice: Yup.number()
  .min(0, 'Average Room price must be 0 or more')
  .required('Average room price is required'),
  venueCapacity: Yup.number().integer('Venue capacity must be an integer').positive('Venue capacity must be a positive number').required('Venue capacity is required'),
  starRating: Yup.number()
  .transform((value, originalValue) => {
    return Number(originalValue) || 0; // fallback to 0 if not numeric
  })
  .min(1, 'Please select a valid star rating')
  .required('Star rating is required'),
  startingPrice: Yup.number()
    .min(0, 'BuyOut Price must be 0 or more'),
    // .required('Starting price is required'),
  // Arrays of objects validation for other multi-select fields
  smallPartiesVenue: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Small Parties Venue value is required'),
      label: Yup.string().required('Small Parties Venue label is required'),
    })
  ).min(1, 'Small Parties Venue field is required'),
  space: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Space value is required'),
      label: Yup.string().required('Space label is required'),
    })
  ).min(1, 'Space field is required'),
  catering: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Catering value is required'),
      label: Yup.string().required('Catering label is required'),
    })
  ).min(1, 'Catering Policy field is required'),
  decorPolicy: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Decor Policy value is required'),
      label: Yup.string().required('Decor Policy label is required'),
    })
  ).min(1, 'Decor Policy field is required'),
  alcoholPolicy: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Alcohol Policy value is required'),
      label: Yup.string().required('Alcohol Policy label is required'),
    })
  ).min(1, 'Alcohol Policy field is required'),
  djPolicy: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('DJ Policy value is required'),
      label: Yup.string().required('DJ Policy label is required'),
    })
  ).min(1, 'DJ Policy field is required'),
});
export const templeTtkSchema = Yup.object({
  parkingSize: Yup.string().required('Parking size is required'),
  vegPrice: Yup.number()
    .min(0, 'Veg price must be a positive number or zero')
    .required('Veg price is required'),
  nonVegPrice: Yup.number()
    .min(0, 'Non Veg price must be a positive number or zero')
    .required('Non Veg price is required'),
  venueCapacity: Yup.number().integer('Venue capacity must be an integer').positive('Venue capacity must be a positive number').required('Venue capacity is required'),
  // Arrays of objects validation for other multi-select fields
  catering: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Catering value is required'),
      label: Yup.string().required('Catering label is required'),
    })
  ).min(1, 'Catering Policy field is required'),
  decorPolicy: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Decor Policy value is required'),
      label: Yup.string().required('Decor Policy label is required'),
    })
  ).min(1, 'Decor Policy field is required'),
  alcoholPolicy: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Alcohol Policy value is required'),
      label: Yup.string().required('Alcohol Policy label is required'),
    })
  ).min(1, 'Alcohol Policy field is required'),
  djPolicy: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('DJ Policy value is required'),
      label: Yup.string().required('DJ Policy label is required'),
    })
  ).min(1, 'DJ Policy field is required'),
});

export const photographerTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  // Arrays of objects validation for other multi-select fields
  travelPrefer: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Travel Preference value is required'),
      label: Yup.string().required('Travel Preference label is required'),
    })
  ).min(1, 'Travel Preference field is required'),
  serviceOffer: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('serviceOffer value is required'),
      label: Yup.string().required('serviceOffer label is required'),
    })
  ).min(1, 'Service Offer field is required'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area Of Work  field is required'),
  deliveryDate: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('delivery Date value is required'),
      label: Yup.string().required('delivery Date label is required'),
    })
  ).min(1, 'Delivery Date field is required'),
  // Additional fields validation
  canditPrice: Yup.number().integer('Candit Price must be an integer'),
  cinematicPrice: Yup.number().integer('Cinematic Price must be an integer'),
  // videographyPrice: Yup.number().integer('Videography Price must be an integer').positive('Videography price must be a positive number').required('Videography price is required'),
  budgetPhotoPrice: Yup.number().integer('Budget Photo Price must be an integer').required('Budget Photo Price is required'),
  budgetVideoPrice: Yup.number().integer('Budget Video Price must be an integer').required('Budget Video price is required'),
  // smallFunctionPhotoPrice: Yup.number().integer('Small Function Photo Price must be an integer').positive('Small Function Photo Price must be a positive number').required('Small Function Photo Price is required'),
  studioPhotoPrice: Yup.number().integer('Studio Photo Price must be an integer'),
  noOfEmployee: Yup.number().integer('No Of Employee must be an integer').required('No Of Employee is required')
});
export const brashBandTtkSchema = Yup.object({

  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  // Arrays of objects validation for other multi-select fields
  serviceOffered: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('serviceOffer value is required'),
      label: Yup.string().required('serviceOffer label is required'),
    })
  ).min(1, 'Service Offer field is required'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area Of Work  field is required'),
  // Additional fields validation
  bandmember: Yup.number().integer('Number Of Band-Member must be an integer').positive('Number Of Band-Member must be a positive number').required('Number Of Band-Member is required'),
  charges: Yup.number().integer('Starting Price must be an integer').positive('Starting Price must be a positive number').required('Starting Price is required'),
});

export const artistTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  choreographerStyle: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Types of Artist value is required'),
      label: Yup.string().required('Types of Artist label is required'),
    })
  ).min(1, 'Types of Artist  field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  price: Yup.number().integer('Starting price must be an integer').positive('Starting price must be a positive number').required('Starting price is required'),
  backDancers: Yup.string().required('You Provide Back Dancers field is required'),
});
export const weddingDjTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  favouriteMusic: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Favourite Music value is required'),
      label: Yup.string().required('Favourite Music label is required'),
    })
  ).min(1, 'Favourite Music field is required'),
  TravelPreference: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Travel Preference value is required'),
      label: Yup.string().required('Travel Preference label is required'),
    })
  ).min(1, 'Travel Preference field is required'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  startingPrice: Yup.number().integer('Starting price must be an integer').positive('Starting price must be a positive number').required('Starting price is required'),
});
export const ChoreographerTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  choreographerStyle: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Choreographer Style value is required'),
      label: Yup.string().required('Choreographer Style label is required'),
    })
  ).min(1, 'Choreographer Style field is required'),
  performancePreference: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Performance Preference value is required'),
      label: Yup.string().required('Performance Preference label is required'),
    })
  ).min(1, 'Performance Preference field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),

  price: Yup.number().integer('Starting price must be an integer').positive('Starting price must be a positive number').required('Starting price is required'),
  backDancers: Yup.string().required('Back Dancers is required'),
});
export const liveMusicTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  typeOfArtist: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Types of Artist value is required'),
      label: Yup.string().required('Types of Artist label is required'),
    })
  ).min(1, 'Types of Artist  field is required'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  eventTypeBand: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('event Type Band value is required'),
      label: Yup.string().required('event Type Band label is required'),
    })
  ).min(1, 'Event Type Band field is required'),
  noOfTeam: Yup.number().integer('No Of Team must be an integer').positive('No Of Team must be a positive number').required('No Of Team is required'),
  coveredOfEvent: Yup.number().integer('Covered Of Event must be an integer').positive('Covered Of Event must be a positive number').required('Covered Of Event is required'),
  duration: Yup.string().required('Back Dancers is required'),
});

export const panditTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),

  language: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('language value is required'),
      label: Yup.string().required('language label is required'),
    })
  ).min(1, 'language  field is required'),

  servicePandit: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('servicePandit value is required'),
      label: Yup.string().required('servicePandit label is required'),
    })
  ).min(1, 'Service Pandit field is required'),

  samagri: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Samagri value is required'),
      label: Yup.string().required('Samagri label is required'),
    })
  ).min(1, 'Samagri field is required'),

  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  kundaliMatchPrice: Yup.number().integer('kundali Match Price must be an integer').positive('kundali Match Price must be a positive number').required('kundali Match Price is required'),
  WeddingPrice: Yup.number().integer('Wedding Price must be an integer').positive('Wedding Price must be a positive number').required('Wedding Price is required'),
});
export const anchorTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),

  language: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('language value is required'),
      label: Yup.string().required('language label is required'),
    })
  ).min(1, 'language  field is required'),
  eventTypeAnchor: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('eventTypeAnchor value is required'),
      label: Yup.string().required('eventTypeAnchor label is required'),
    })
  ).min(1, 'event Type Anchor field is required'),

  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  startingPrice: Yup.number().integer('starting Price must be an integer').positive('starting Price must be a positive number').required('starting Price is required'),
  Duration: Yup.string().required('Duration is required'),
});

export const decoratorTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),

  planningType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('planningType value is required'),
      label: Yup.string().required('planningType label is required'),
    })
  ).min(1, 'Planning Type  field is required'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  indoorBudget: Yup.number().integer('Indoor Budget must be an integer').positive('Indoor Budget must be a positive number').required('Indoor Budget is required'),
  outdoorBudget: Yup.number().integer('Outdoor Budget must be an integer').positive('Outdoor Budget must be a positive number').required('Outdoor Budget is required'),
  homeFunction: Yup.number().integer('Home Function must be an integer').positive('Home Function must be a positive number').required('Home Function is required'),
});

export const cateringTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  vegPrice: Yup.number().integer('Veg Price must be an integer').positive('Veg Price must be a positive number').required('Veg Price is required'),
  nonVegPrice: Yup.number().integer('Non-Veg Price must be an integer').positive('Non-Veg Price must be a positive number'),
  maxCap: Yup.number().integer('Maximum Capacity must be an integer').positive('Maximum Capacity must be a positive number').required('Maximum Capacity is required'),
  minCap: Yup.number().integer('Minimum Capacity must be an integer').positive('Minimum Capacity must be a positive number').required('Minimum Capacity is required'),
});

export const groomTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  serviceOfferedGroom: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('serviceOfferedGroom value is required'),
      label: Yup.string().required('serviceOfferedGroom label is required'),
    })
  ).min(1, 'Service Offered Groom field is required'),
  storeTypeGroom: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('storeTypeGroom value is required'),
      label: Yup.string().required('storeTypeGroom label is required'),
    })
  ).min(1, 'Store Type Groom field is required'),
  deliveryDate: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('deliveryDate value is required'),
      label: Yup.string().required('deliveryDate label is required'),
    })
  ).min(1, 'Delivery Date field is required'),
  startingPrice: Yup.number().integer('Starting Price must be an integer').positive('Starting Price must be a positive number').required('Starting Price is required'),
  sherwaniPrice: Yup.number().integer('Sherwani Price must be an integer').positive('Sherwani Price must be a positive number').required('Sherwani Price is required'),
});

export const bridalTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  serviceOffered: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('serviceOffered value is required'),
      label: Yup.string().required('serviceOffered label is required'),
    })
  ).min(1, 'Service Offered field is required'),
  customization: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('customization value is required'),
      label: Yup.string().required('customization label is required'),
    })
  ).min(1, 'Customization field is required'),
  storeType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('storeType value is required'),
      label: Yup.string().required('storeType label is required'),
    })
  ).min(1, 'Store Type field is required'),
});
export const clotingRentalTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  serviceOfferedOnRent: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('serviceOfferedOnRent value is required'),
      label: Yup.string().required('serviceOfferedOnRent label is required'),
    })
  ).min(1, 'Service offer on rent field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area of working field is required'),
  coveredOfEvent: Yup.number().integer('Covered Of Event must be an integer').positive('Covered Of Event must be a positive number').required('Covered Of Event is required'),

});
export const makeupTtkSchema = Yup.object({
  bridalMakeupPrice: Yup.number().integer('Bridal Makeup Price must be an integer').positive('Bridal Makeup Price must be a positive number').required('Bridal Makeup Price is required'),
  airBrushBridalMakeupPrice: Yup.number().integer('Air Brush Bridal Makeup Price must be an integer').positive('Air Brush Bridal Makeup Price must be a positive number').required('Air Brush Bridal Makeup Price is required'),
  partyMakeupPrice: Yup.number().integer('Party Makeup Price must be an integer').positive('Party Makeup Price must be a positive number').required('Party Makeup Price is required'),
  // outStationMakeupCharges: Yup.number().integer('OutStation Makeup Charges must be an integer').positive('OutStation Makeup Charges must be a positive number').required('OutStation Makeup Charges is required'),
  // outStationMakeupCharges: Yup.array()
  // .of(
  //   Yup.object().shape({
  //     value: Yup.string().required('OutStation Makeup Charges Value is required'),
  //     label: Yup.string().required('OutStation Makeup Charges Label is required'),
  //   })
  // )
  // .min(1, 'OutStation Makeup Charges field is required')
  // .max(1, 'Only one value can be selected from OutStation Makeup Charges'),
  engagementMakeupPrice: Yup.number().integer('Engagement Makeup Price must be an integer').positive('Engagement Makeup Price must be a positive number').required('Engagement Makeup Price is required'),
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  productUsed: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('productUsed value is required'),
      label: Yup.string().required('productUsed label is required'),
    })
  ).min(1, 'Product Used field is required'),
  sericeProvided: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('sericeProvided value is required'),
      label: Yup.string().required('sericeProvided label is required'),
    })
  ).min(1, 'Serice Provided field is required'),
});
export const mehandiTtkSchema = Yup.object({
  mehandiPrice: Yup.number().integer('Mehandi Price must be an integer').positive('Mehandi Price must be a positive number').required('Mehandi Price is required'),
  noOfEmployee: Yup.number().integer('No Of Employee must be an integer').positive('No Of Employee must be a positive number').required('No Of Employee is required'),
  mehandiPerHandPrice: Yup.number().integer('Mehandi PerHand Price must be an integer').positive('Mehandi PerHand Price must be a positive number').required('Mehandi PerHand Price is required'),
  TranditionalMehandi: Yup.number().integer('Tranditional Mehandi must be an integer').positive('Tranditional Mehandi must be a positive number').required('Tranditional Mehandi is required'),
  maxGuest: Yup.number().integer('Maximun Guest must be an integer').positive('Maximun Guest must be a positive number').required('Maximun Guest is required'),
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  mehandiDesign: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('mehandiDesign value is required'),
      label: Yup.string().required('mehandiDesign label is required'),
    })
  ).min(1, 'Mehandi Design field is required'),
  travelCost: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('travelCost value is required'),
      label: Yup.string().required('travelCost label is required'),
    })
  ).min(1, 'Travel Cost field is required'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area or work field is required'),
  TravelPreference: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('TravelPreference value is required'),
      label: Yup.string().required('TravelPreference label is required'),
    })
  ).min(1, 'Travel Preference field is required'),
});
export const vintageCarTtkSchema = Yup.object({
  PiecePrice: Yup.number().integer('Piece Price must be an integer').positive('Piece Price must be a positive number').required('Piece Price is required'),
  seatAvailable: Yup.number().integer('Seat Available must be an integer').positive('Seat Available must be a positive number').required('Seat Available is required'),
   workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  helecopterName: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('vintageCarsServices value is required'),
      label: Yup.string().required('vintageCarsServices label is required'),
    })
  ).min(1, 'Vintage Cars Services field is required'),
  vintageCarsName: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('vintageCarsName value is required'),
      label: Yup.string().required('vintageCarsName label is required'),
    })
  ).min(1, 'Vintage Cars Name field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area or work field is required'),
});
export const helecopterTtkSchema = Yup.object({
  PiecePrice: Yup.number().integer('Piece Price must be an integer').positive('Piece Price must be a positive number').required('Piece Price is required'),
  seatAvailable: Yup.number().integer('Seat Available must be an integer').positive('Seat Available must be a positive number').required('Seat Available is required'),
   workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    vehicle: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Event Service Value is required'),
        label: Yup.string().required('Event Service Label is required'),
      })
    )
    .min(1, 'Event Service field is required'),
  helecopterName: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('helecopterName value is required'),
      label: Yup.string().required('helecopterName label is required'),
    })
  ).min(1, 'Helecopter Name field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area or work field is required'),
});
export const rentalCarTtkSchema = Yup.object({
  price: Yup.number().integer('Price must be an integer').positive('Price must be a positive number').required('Price is required'),
   workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    vehicle: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('vehicle Value is required'),
        label: Yup.string().required('vehicle Label is required'),
      })
    )
    .min(1, 'Vehicle field is required'),
  duration: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('duration value is required'),
      label: Yup.string().required('duration label is required'),
    })
  ).min(1, 'Duration field is required'),
  purpose: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('purpose value is required'),
      label: Yup.string().required('purpose label is required'),
    })
  ).min(1, 'Purpose field is required'),
  tourProvided: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('driveType value is required'),
      label: Yup.string().required('driveType label is required'),
    })
  ).min(1, 'Drive Type field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area or work field is required'),
});
export const tourPackageTtkSchema = Yup.object({
  price: Yup.number().integer('Price must be an integer').positive('Price must be a positive number').required('Price is required'),
   workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    travelPreference: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('travelPreference Value is required'),
        label: Yup.string().required('travelPreference Label is required'),
      })
    )
    .min(1, 'Travel Preference field is required'),
    durationType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('duration value is required'),
      label: Yup.string().required('duration label is required'),
    })
  ).min(1, 'Duration field is required'),
  travellingType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('travellingType value is required'),
      label: Yup.string().required('travellingType label is required'),
    })
  ).min(1, 'Travelling Type field is required'),
  tourProvided: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('tourProvided value is required'),
      label: Yup.string().required('tourProvided label is required'),
    })
  ).min(1, 'Tour Provided field is required'),
});
export const rentalBusTtkSchema = Yup.object({
  price: Yup.number().integer('Price must be an integer').positive('Price must be a positive number').required('Price is required'),
   workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    birthadayDecoration: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('vehicle Value is required'),
        label: Yup.string().required('vehicle Label is required'),
      })
    )
    .min(1, 'Bus Vehicle field is required'),
  busType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('busType value is required'),
      label: Yup.string().required('busType label is required'),
    })
  ).min(1, 'Bus Type field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area or work field is required'),
});
export const birthdayShoppingTtkSchema = Yup.object({
  price: Yup.number().integer('Price must be an integer').positive('Price must be a positive number').required('Price is required'),
   workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    birthadayDecoration: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('birthadayDecoration Value is required'),
        label: Yup.string().required('birthadayDecoration Label is required'),
      })
    )
    .min(1, 'Birthaday Decoration field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area or work field is required'),
});
export const birthdayDecoratorTtkSchema = Yup.object({

  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  serviceType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('serviceType value is required'),
      label: Yup.string().required('serviceType label is required'),
    })
  ).min(1, 'Service Type field is required'),
  indoorBudget: Yup.number().integer('Indoor Budget must be an integer').positive('Indoor Budget must be a positive number').required('Indoor Budget is required'),
  outdoorBudget: Yup.number().integer('Outdoor Budget must be an integer').positive('Outdoor Budget must be a positive number').required('Outdoor Budget is required'),
  homeFunction: Yup.number().integer('Home Function must be an integer').positive('Home Function must be a positive number').required('Home Function is required'),
});
export const birthdayClubbingTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  // Additional fields validation
  parkingSize: Yup.string().required('Parking size is required'),
  vegPrice: Yup.number().positive('Vegetarian price must be a positive number').required('Vegetarian price is required'),
  nonVegPrice: Yup.number().required('Non-Vegetarian price is required'),
  roomCount: Yup.number().integer('Room count must be an integer').required('Room count is required'),
  maxCapicity: Yup.number().positive('Maximum Capicity must be a positive number').required('Maximum Capicity is required'),
  minCapicity: Yup.number().positive('coverd of events must be a positive number').required('Minimum Capicity is required'),
  // Arrays of objects validation for other multi-select fields
  smallPartiesVenue: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Small Parties Venue value is required'),
      label: Yup.string().required('Small Parties Venue label is required'),
    })
  ).min(1, 'Small Parties Venue field is required'),
  space: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Space value is required'),
      label: Yup.string().required('Space label is required'),
    })
  ).min(1, 'Space field is required'),
  parking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('parking value is required'),
      label: Yup.string().required('parking label is required'),
    })
  ).min(1, 'parking field is required'),
 
});
export const magicianTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    coverdofevents: Yup.number().positive('coverd of events must be a positive number').required('coverd of events is required'),
  eventtype: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('eventtype Venue value is required'),
      label: Yup.string().required('eventtype Venue label is required'),
    })
  ).min(1, 'event type Venue field is required'),
  requirement: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('requirement value is required'),
      label: Yup.string().required('requirement label is required'),
    })
  ).min(1, 'requirement field is required'),
  duration: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('duration value is required'),
      label: Yup.string().required('duration label is required'),
    })
  ).min(1, 'duration field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
 
});

export const cakeShopTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    price: Yup.number().positive('price must be a positive number').required('price is required'),
  popularFlavourCake: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('popularFlavourCake Venue value is required'),
      label: Yup.string().required('popularFlavourCake Venue label is required'),
    })
  ).min(1, 'Popular Flavour Cake field is required'),
  specialtyCake: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('specialtyCake value is required'),
      label: Yup.string().required('specialtyCake label is required'),
    })
  ).min(1, 'Specialty Cake field is required'),
  cakesShape: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('cakesShape value is required'),
      label: Yup.string().required('cakesShape label is required'),
    })
  ).min(1, 'Cakes Shape field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
});
export const invitationTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    PiecePrice: Yup.number().positive('price must be a positive number').required('price is required'),
    invites: Yup.number().positive('invites must be a positive number').required('invites is required'),
    order: Yup.number().positive('order must be a positive number').required('order is required'),
    boxed: Yup.number().positive('boxed must be a positive number').required('boxed is required'),
  cardSpecialty: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('cardSpecialty Venue value is required'),
      label: Yup.string().required('cardSpecialty Venue label is required'),
    })
  ).min(1, 'Card Specialty field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
});
export const giftsTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    PiecePrice: Yup.number().positive('price must be a positive number').required('price is required'),
    favourGifts: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('favourGifts Venue value is required'),
      label: Yup.string().required('favourGifts Venue label is required'),
    })
  ).min(1, 'Favour Gifts field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
});

export const floristTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  coverdofevents: Yup.number().positive('Coverd of events must be a positive number').required('Coverd of events is required'),
    serviceOffered: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Service Offered Value is required'),
        label: Yup.string().required('Service Offered Label is required'),
      })
    )
    .min(1, 'Service Offered field is required'),
  planningType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('planningType Venue value is required'),
      label: Yup.string().required('planningType Venue label is required'),
    })
  ).min(1, 'planningType field is required'),
  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  travelPreference: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('travelPreference Value is required'),
        label: Yup.string().required('travelPreference Label is required'),
      })
    )
    .min(1, 'Travel Preference field is required'),
});

export const corporateTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    CoverdofEvents: Yup.number().positive('Coverd of events must be a positive number').required('Coverd of events is required'),
    Fees: Yup.string().required('Fees is required'),
    budget: Yup.number().positive('budget must be a positive number').required('budget is required'),
  planningType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('planningType Venue value is required'),
      label: Yup.string().required('planningType Venue label is required'),
    })
  ).min(1, 'planningType field is required'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
});
export const govtTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
    CoverdofEvents: Yup.number().positive('Coverd of events must be a positive number').required('Coverd of events is required'),
    Fees: Yup.string().required('Fees is required'),
  planningType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('planningType Venue value is required'),
      label: Yup.string().required('planningType Venue label is required'),
    })
  ).min(1, 'planningType field is required'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWork value is required'),
      label: Yup.string().required('areaOfWork label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
});

export const entryThemeTtkSchema = Yup.object({

  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),
  areaOfWork: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Area Of Working value is required'),
      label: Yup.string().required('Area Of Working label is required'),
    })
  ).min(1, 'Area Of Working field is required'),
  serviceType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Service Type value is required'),
      label: Yup.string().required('Service Type label is required'),
    })
  ).min(1, 'Service Type field is required'),
  startingPrice: Yup.number().integer('Starting Price must be an integer').positive('Starting Price must be a positive number').required('Starting Price is required'),
  CoverdofEvents: Yup.number().integer('Covered of events must be an integer').positive('Covered of events must be a positive number').required('Covered of events is required'),

});
export const jewelleryTtkSchema = Yup.object({
  workingSince: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Working Since Value is required'),
        label: Yup.string().required('Working Since Label is required'),
      })
    )
    .min(1, 'Working Since field is required')
    .max(1, 'Only one value can be selected from Working Since'),

  areaOfWorking: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('areaOfWorking value is required'),
      label: Yup.string().required('areaOfWorking label is required'),
    })
  ).min(1, 'Area Of Working field is required'),

  jewelleryType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Type Of jewelleryType value is required'),
      label: Yup.string().required('Type Of jewelleryType label is required'),
    })
  ).min(1, 'planningType field is required'),

  categoriesServe: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Type Of categories value is required'),
      label: Yup.string().required('Type Of categories label is required'),
    })
  ).min(1, 'planningType field is required'),

  storeType: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required('Type Of storeType value is required'),
      label: Yup.string().required('Type Of storeType label is required'),
    })
  ).min(1, 'planningType field is required'),

   rentalJewellery: Yup.string()
    .required('Please select rental jewellery availability')
    .oneOf(['available', 'not available'], 'Invalid option selected'),

  customization: Yup.string()
    .required('Please select customization availability')
    .oneOf(['available', 'not available'], 'Invalid option selected'),

});
// export const productSchema = Yup.object().shape({
//   name: Yup.string().required('Product Name is required'),
//   name: Yup.string().required('Product Name is required'),
//   price: Yup.number()
//     .typeError('Price must be a number')
//     .required('Price is required')
//     .positive('Price must be a positive number'),

//   discountedPrice: Yup.number()
//     .typeError('Discounted price must be a number')
//     .positive('Discounted price must be a positive number')
//     .when('price', (price, schema) => {
//       return schema.test({
//         test: discountedPrice => {
//           // Validate that discounted price is less than or equal to the original price
//           return discountedPrice <= price;
//         },
//         message: 'Discounted price must be less than or equal to the original price',
//       });
//     }),
// });
export const workingAddressSchema = Yup.object().shape({
  country_id: Yup.string().required("Country is required"),
  state_id: Yup.string().required("State is required"),
  city_id: Yup.string().required("City is required"),
  locality_id: Yup.string().when("country_id", {
    is: (val) => val === "4Dj1nUEkp4vFOh4HI0CL",
    then: (schema) => schema.required("Locality is required"),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  pincode: Yup.string()
    .matches(/^[0-9]{4,6}$/, "Invalid Pincode")
    .required("Pincode is required"),  
  full_address: Yup.string().nullable(), 
});